import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col, Divider, Icon, Table, Modal, Avatar, Input, Badge } from 'antd';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import _ from 'underscore';
import $ from 'jquery';
import './style.css';

// Actions
import { get_employee, get_company, delete_employee, set_employee_approve, request_join_employee } from './actions/employee.action';

import RequestJoin from './childs/request.join';

const confirm = Modal.confirm;

class Employee extends Component {

    constructor( props ){
        super( props )

        this.state = {
            data: [],
            company: [],
            company_filter: [{ text: 'None', value: 'None' }],
            department_filter: [{ text: 'None', value: 'None' }],
            designation_filter: [{ text: 'None', value: 'None' }],
            requestmodal: false,
            searchText: ''
        }

        this.handleRequestJoin = this.handleRequestJoin.bind( this );
        this.handleEdit = this.handleEdit.bind( this );
        this.handleDelete = this.handleDelete.bind( this );
        this.handleApprove = this.handleApprove.bind( this );
        this.handelSubmit = this.handelSubmit.bind( this );
        this.getColumnSearchProps = this.getColumnSearchProps.bind( this );
        this.handleChangeTable = this.handleChangeTable.bind( this );

    }

    handleChangeTable(){
        setTimeout(() => {
            $('.Active').parent().parent().css({ 'background-color': '#c9f9ba' });
            $('.Terminated').parent().parent().css({ 'background-color': '#f7acac' });
            $('.Deceased').parent().parent().css({ 'background-color': '#f2f9ba' });
            $('.Resigned').parent().parent().css({ 'background-color': '#e0e0e0' });
            $('.Onboard').parent().parent().css({ 'background-color': '#bacdf9' });
        }, 100);
    }

    componentDidMount(){
        setTimeout(()=>{
            $('.Active').parent().parent().css({ 'background-color': '#c9f9ba' });
            $('.Terminated').parent().parent().css({ 'background-color': '#f7acac' });
            $('.Deceased').parent().parent().css({ 'background-color': '#f2f9ba' });
            $('.Resigned').parent().parent().css({ 'background-color': '#e0e0e0' });
            $('.Onboard').parent().parent().css({ 'background-color': '#bacdf9' });
        }, 1500);
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}>
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>Reset</Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select() );
                }
        }
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }
    
    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    handleEdit( e ){
        console.log( this );
    }

    handleDelete( e ){
        let self = this;
        let id = e.target.attributes.id.value;
        
        confirm({
            title: 'Do you Want to delete this Employee?',
            onOk() {
                self.props.delete_employee( id );
            },
            onCancel() {
                // Nothing
            },
        });
    }
    
    handleApprove( e ){
        this.props.set_employee_approve( e.target.attributes.id.value );
    }

    handleRequestJoin( e ){
        this.setState({ requestmodal: true })
    }

    handelSubmit( data ){
        this.props.request_join_employee( data );
    }

    componentWillMount(){
        this.props.get_employee();
        this.props.get_company();
    }

    getUnique(arr, comp) {

        const unique = arr
             .map(e => e[comp])
      
           // store the keys of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)
      
          // eliminate the dead keys & store unique objects
          .filter(e => arr[e]).map(e => arr[e]);
      
         return unique;
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.employee.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        if( nextProps.employee.STATUS.CODE === "200" && 
            nextProps.employee.STATUS.MESSAGE === "Successfully Listed Employee" ) {

            let data_temp_department = [];
            let data_temp_designation = [];

            nextProps.employee.OUTPUT.DATA.map( (item, k) => {
                if( item.department ){
                    data_temp_department.push( { text: item.department, value: item.department } );
                }
            });

            nextProps.employee.OUTPUT.DATA.map( (item, k) => {
                if( item.designation ){
                    data_temp_designation.push( { text: item.designation, value: item.designation } );
                }
            });

            this.setState({
                data: nextProps.employee.OUTPUT.DATA,
                department_filter: this.getUnique( data_temp_department, 'text' ),
                designation_filter: this.getUnique( data_temp_designation, 'text' ),
                requestmodal: false
            })

        } else if( nextProps.employee.STATUS.CODE === "200" && 
            nextProps.employee.STATUS.MESSAGE === "Successfully Listed Company" ) {

            let data_temp = [];
            
            nextProps.employee.OUTPUT.DATA.map( (item, k) => {
                data_temp.push( { text: item.company_name, value: item.company_name } );
            });

            this.setState({
                company: nextProps.employee.OUTPUT.DATA,
                company_filter: data_temp,
                requestmodal: false
            });

        } else if( nextProps.employee.STATUS.CODE === "200" && 
            nextProps.employee.STATUS.MESSAGE === "Successfully Deleted Employee" ) {
            
            this.props.get_employee();
            this.props.get_company();

            this.setState({
                requestmodal: false
            })

        } else if( nextProps.employee.STATUS.CODE === "200" && 
            nextProps.employee.STATUS.MESSAGE === "Successfully Approved" ) {
            this.props.get_employee();
            this.props.get_company();
            this.setState({
                requestmodal: false
            })
        }

    }

    render() {
        
        const columns = [
            {
                title: 'Name',
                width: '18.25%',
                key: 'name',
                render: ( data ) => <span className={ data.employee_status }>
                    <Avatar className="custome_pic" size="small" src={ data.picture } />
                    &nbsp;{ data.name }
                </span>,
                ...this.getColumnSearchProps( 'name' )
            },
            {
                title: 'Company',
                dataIndex: 'company',
                key: 'company',
                width: '13.25%',
                filters: this.state.company_filter,
                onFilter: (value, record) => record.company.indexOf(value) === 0,
            },
            {
                title: 'Department',
                dataIndex: 'department',
                key: 'department',
                width: '14.25%',
                filters: this.state.department_filter,
                onFilter: (value, record) => record.department.indexOf(value) === 0,
            },
            {
                title: 'Designation',
                dataIndex: 'designation',
                key: 'designation',
                width: '14.25%',
                filters: this.state.designation_filter,
                onFilter: (value, record) => record.designation.indexOf(value) === 0,
            },
            {
                title: 'Status',
                dataIndex: 'employee_status',
                filters: [
                    { text: 'Active', value: 'Active' }, 
                    { text: 'Terminated', value: 'Terminated' },
                    { text: 'Deceased', value: 'Deceased' },
                    { text: 'Resigned', value: 'Resigned' },
                    { text: 'Onboard', value: 'Onboard' },
                ],
                onFilter: (value, record) => record.employee_status.indexOf(value) === 0,
                key: 'employee_status',
                width: '9.25%',
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                width: '16.25%',
            },
            {
                title: 'Action',
                key: 'action',
                render: data => <span>
                    <Link to={ 'employees/'+ data.id } style={{fontSize: 11}}>
                        <Button className="mrg_r_10" icon="edit" size="small" type="primary"></Button>
                    </Link>
                    <Button className="mrg_r_10" size="small" id={ data.id } onClick={ this.handleDelete } icon="delete" type="danger"></Button>
                    <Button size="small" id={ data.id } onClick={ this.handleApprove }>{ ( data.admin_check === '0' ) ? 'Approve' : 'Reject' }</Button>
                </span>,
                width: '14.25%',
            }
        ]

        return (
            <div className="employee_wrapper">

                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="user" />
                            &nbsp; Employees
                        </h2>
                    </Col>
                    <Col span={12}>
                        <Button
                            onClick={ this.handleRequestJoin }
                            className="fl_right" type="primary" icon="plus">Request To Join</Button>
                        
                        <div style={{ marginTop: '4px', marginRight: '10px', float: 'right' }}>
                            <Badge color="#c9f9ba" text="Active" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#f7acac" text="Terminated" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#f2f9ba" text="Deceased" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#e0e0e0" text="Resigned" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#bacdf9" text="Onboard" />
                        </div>
                        
                    </Col>
                </Row>

                <Divider />

                <Row>
                    <Col span={24}>
                        <Table 
                            onChange={ this.handleChangeTable }
                            columns={ columns } 
                            dataSource={ this.state.data }/>
                    </Col>
                </Row>

                <RequestJoin
                    onSubmit={ this.handelSubmit } company={ this.state.company } onModal={ this.state.requestmodal } />             
                
            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        employee: state.employee
    }
}

export default connect( mapStatetoProps, { get_employee, get_company, delete_employee, set_employee_approve, request_join_employee } )( Employee );



// WEBPACK FOOTER //
// ./src/pages/employee/index.js